
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.571 8.632l.867.5L2.186 11.3l-1.367.367L2.57 8.632zm3.536.885L.904 6.513c.783-1.356 1.227-2.034 2.634-2.686.435-.201.722-.334.99-.8C5.122 2 4.177 1.846 5.092.26l4.336 2.503C8.523 4.33 7.9 3.618 7.313 4.635c-.269.465-.24.78-.197 1.258.139 1.546-.228 2.27-1.01 3.624z","fill":"#374250"}})])
          )
        }
      }
    